import React, {ReactNode} from "react";
import FlexBox from "view/components/Layout/FlexBox";
import {Typography} from "@material-ui/core";
import clsx from "clsx";
import useStyles from "./styles";

type PaymentButtonProps = {
  active: boolean;
  icon: ReactNode;
  label: ReactNode;
  onClick: () => void;
};

const PaymentButton = ({active, icon, label, onClick}: PaymentButtonProps) => {
  const classes = useStyles();
  return (
    <FlexBox
      className={clsx(classes.wrapper, {[classes.active]: active})}
      onClick={onClick}
    >
      {icon}
      <Typography
        variant="h4"
        className={clsx(classes.label, {[classes.activeLabel]: active})}
      >
        {label}
      </Typography>
    </FlexBox>
  );
};

export default PaymentButton;
